import animationConfig from '../../configs/animations/index';

/** @typedef {import('@/types').RootState} RootState */
/** @typedef {import('@/types').AnimationState} AnimationState */
/** @typedef {import('vuex').GetterTree<AnimationState, RootState>} AnimationGetters */

const {
    items,
    poster_postfix,
    quality,
    resolution,
    thumbnail_postfix,
} = /** @type {import('@/types').AnimationProps & import('@/types').Animations} */ animationConfig;

/** @type {import('@/types').AnimationState} */
const state = {
    props: {
        poster_postfix,
        quality,
        resolution,
        thumbnail_postfix,
    },
    activeId: null,
    animationItems: [],
    lastSearch: null,
    scrollPos: 0,
};

/** @type {AnimationGetters} */
const getters = {
    animationItems(state) {
        state.animationItems = items;
    },
};

const store = {
    namespaced: true,
    getters,
    state,
};

export default store;
